import { render, staticRenderFns } from "./ClinicDetails.vue?vue&type=template&id=3ba7ad8e&scoped=true"
import script from "./ClinicDetails.vue?vue&type=script&lang=js"
export * from "./ClinicDetails.vue?vue&type=script&lang=js"
import style0 from "./ClinicDetails.vue?vue&type=style&index=0&id=3ba7ad8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba7ad8e",
  null
  
)

export default component.exports